import axios from "axios"

export default async (form) => {
    const formElementContainer = form.querySelector('.form-element-container')
    const spinner = form.querySelector('.spinner')
    const errorMsg = form.querySelector('.error-msg')
    const footer = form.querySelector('.modal-footer')
    const modal = form.querySelector('.modal');
    modal.addEventListener('show.bs.modal', () => {
        footer.classList.remove('hidden')
    })

    form.addEventListener('submit', async evt => {
        evt.preventDefault()
        formElementContainer.classList.add('hidden')
        footer.classList.add('hidden')
        spinner.classList.remove('hidden')

        form.querySelectorAll('ul.form-errors').forEach(ul => ul.remove())

        try {
            const response = await axios.post(
                form.action,
                new FormData(form)
            )
            if (response.status < 400) {
                if (response.headers.has('location')) {
                    window.location.href = response.headers.get('location')
                    return;
                }
                history.scrollRestoration = 'manual';
                window.location.reload()
                return
            }

            formElementContainer.innerHTML = response.data
        } catch (e) {
            spinner.classList.add('hidden')
            const response = e.response
            if (!response || response.status !== 422) {
                errorMsg.classList.remove('hidden')
                return
            }
            const formErrors = response.data.formErrors
            const handledElements = []
            document.querySelectorAll('input[name="csrf"]').forEach(input => {
                input.value = response.data.csrf
            })
            for (const [inputName, messages] of Object.entries(formErrors)) {
                if (handledElements.includes(inputName)) {
                    return
                }
                handledElements.push(inputName)
                const inputElement = form.querySelector(`[name="${inputName}"]`)
                const ul = document.createElement('ul')
                ul.classList.add('form-errors', 'text-danger', 'list-unstyled', 'mx-2', 'my-2')
                messages.forEach(message => {
                    const li = document.createElement('li')
                    li.innerText = message
                    ul.appendChild(li)
                })
                inputElement.parentNode.append(ul)
            }
            footer.classList.remove('hidden')
            formElementContainer.classList.remove('hidden')
            spinner.classList.add('hidden')
        }
    })
}
